import React from 'react';
import { charMaps as C, applyMap } from '../lib/unicode';

// Original illustrative card that renders sample Unicode styles (replaces static images)
export default function StylePreviewCard({ title, rows, accent = 'var(--brand)' }) {
  return (
    <div className="rounded-xl bg-[var(--cream)] border border-[var(--line)] shadow-[0_12px_30px_-12px_rgba(113,59,87,0.16)] overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-testid="style-preview-card">
      <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-[var(--line)] bg-[var(--paper2)]">
        <span className="w-2.5 h-2.5 rounded-full bg-[#f28b82]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#fbd38d]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#9ae6b4]" />
        <span className="ml-3 text-[11px] tracking-[0.12em] uppercase font-semibold text-[var(--ink3)] font-outfit">{title}</span>
      </div>
      <div className="divide-y divide-[var(--line)]">
        {rows.map(([label, text]) => (
          <div key={label} className="flex items-center justify-between gap-4 px-4 py-3">
            <span className="text-[10px] uppercase tracking-[0.1em] font-semibold font-outfit" style={{ color: accent }}>{label}</span>
            <span className="text-[19px] text-[var(--ink)] truncate">{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export const sample = (fn, t = 'Beautiful Words') => applyMap(t, fn);
export { C };
